import React from "react"
import HOC from './Container'

export default class Numbers extends React.PureComponent {
  state = {
    counterNumber: 0,
    ageNumber: 0,
    ageNumber40: 0,
    ageNumber30: 0,
    ageNumber20: 0,
    genderMan: 0,
    genderWoman: 0,
    newGrads: 0,
    midCareer : 0,

    director: 0,
    designer: 0,
    engineer: 0,
    sales: 0,
    accounting: 0,
    supportDesk: 0,

    businessClothes: 0,
    officeCasual: 0,
    casualClothes: 0,

    dayOffPercentage: 0,
    refreshCounter: 0,
    childCounter: 0,

    officerCounter: 0,
    sitecoreNumber: 10,
    income: 0,
  }

  counterNumber = (max, state, callback, delay, isReverse) => {
    let cnt = isReverse ? this.state[state] - 1 : 1
    let a = {}
    let interval = delay ? delay : 20
    let counterInterval = setInterval(() => {
      let maxCondition = (isReverse) ? (cnt + 1) : (cnt - 1)

      if (maxCondition === max) {
        clearInterval(counterInterval)
        if (callback) callback()
        return
      }

      a[state] = cnt
      this.setState(a)
      if(isReverse) cnt--
      else cnt++
    }, interval)
  } 

  componentDidMount() {                
    
  }

  render() {
    const {
      counterNumber,
      ageNumber,
      ageNumber20,
      ageNumber30,
      ageNumber40,
      genderMan,
      genderWoman,
      newGrads,
      midCareer,
      director,
      designer,
      engineer,
      sales,
      accounting,
      supportDesk,
      businessClothes,
      officeCasual,
      casualClothes,
      dayOffPercentage,
      refreshCounter,
      childCounter,
      officerCounter,
      sitecoreNumber,
      income,
    } = this.state

    return HOC({
      counterNumber,
      ageNumber,
      ageNumber20,
      ageNumber30,
      ageNumber40,
      genderMan,
      genderWoman,
      newGrads,
      midCareer,
      director,
      designer,
      engineer,
      sales,
      accounting,
      supportDesk,
      businessClothes,
      officeCasual,
      casualClothes,
      dayOffPercentage,
      refreshCounter,
      childCounter,
      officerCounter,
      sitecoreNumber,
      income,
    })
  }
}



// WEBPACK FOOTER //
// ./src/Home/Numbers/index.js